module.exports = __webpack_public_path__ + "static/img/sean-kong-491810-unsplash.c7daf13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/sean-kong-491810-unsplash.jpg
// module id = EAqz
// module chunks = 1